/**
 * Created by mnaughton on 12/3/2015.
 */

import BaseContext from "core/base/Context";
import logger from "app/Logger";

export default BaseContext.extend({
  initialize: function () {
    BaseContext.prototype.initialize.apply(this, arguments);

    this.operations.on(
      "all",
      function (name, model, options) {
        logger.operation(name, options);
      },
      this
    );
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/LoggingContext.js
// module id = 873
// module chunks = 1